// extracted by mini-css-extract-plugin
export default {"upsContainer":"Features_upsContainer__8O6r7"};